import { Classes, HotkeyConfig, KeyComboTag } from '@clarion-blueprint-shim';
import { ClarionDialog } from '../clarion/ClarionDialog';

type Props = {
  hotkeys: HotkeyConfig[];
  isOpen: boolean;
  onClose: () => void;
};

export default function HotkeysDialog({ hotkeys, isOpen, onClose }: Props) {
  // Group hotkeys by label
  const groupedHotkeys = hotkeys.reduce(
    (acc, hotkey) => {
      const label = hotkey.label;
      if (typeof label !== 'string') {
        console.error('Hotkey label is not a string and will not be displayed', hotkey);
        return acc;
      }
      if (!acc[label]) {
        acc[label] = [];
      }
      acc[label].push(hotkey);
      return acc;
    },
    {} as Record<string, HotkeyConfig[]>,
  );

  return (
    <ClarionDialog isOpen={isOpen} onClose={onClose} title="Keyboard Shortcuts" showCloseButton>
      <div className="columns-1 md:columns-2 gap-x-8 mt-4 ">
        {Object.entries(groupedHotkeys).map(([label, hotkeyGroup], index) => (
          <div key={index} className="flex gap-2 items-start justify-between mb-6">
            <div className={Classes.HOTKEY_LABEL}>{label}</div>
            <div className="flex flex-col gap-2 items-end">
              {hotkeyGroup.map((hotkey, hotkeyIndex) => (
                <KeyComboTag key={hotkeyIndex} combo={hotkey.combo} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </ClarionDialog>
  );
}
